import {
  EXCHANGE_REWARD_TNC,
  EXCHANGE_REWARDS_TYPE_1,
  EXCHANGE_REWARDS_TYPE_2
} from '~/utils/api-response/missions'
import { REWARDS } from '~/utils/api-response/missions/exchange/reward'
import { COIN_HISTORY, PLAYER_EXCHANGE_HISTORY } from '~/utils/api-response/player'

export const state = () => ({
  creditTiers: [],
  itemTiers: [],
  rewards: REWARDS,
  rewardsLoading: {},
  exchangeRewardTermAndCondition: {},
  rewardHistories: { data: [] },
  coinHistories: { data: [] },
  getAllTiersLoading: {}
})

export const actions = {
  // Get tiers
  getAllTiers({ commit }, params) {
    commit('setCreditTiers', EXCHANGE_REWARDS_TYPE_1?.data?.data)
    commit('setItemTiers', EXCHANGE_REWARDS_TYPE_2?.data?.data)
  },
  async getTierRewards({ commit }, params) {},
  onClaimReward({ _ }, { rewardId, body }) {
    return {
      status: true
    }
  },
  getExchangeRewardTermAndCondition({ commit }, params) {
    commit('setExchangeRewardTermAndCondition', EXCHANGE_REWARD_TNC.data?.data)
  },
  getRewardHistories({ commit }, data) {
    commit('setRewardHistories', PLAYER_EXCHANGE_HISTORY.data)
  },
  getCoinHistories({ commit }, params) {
    commit('setCoinHistories', COIN_HISTORY.data)
  }
}

export const mutations = {
  setCreditTiers: (state, data) => {
    state.creditTiers = data
  },
  setItemTiers: (state, data) => {
    state.itemTiers = data
  },
  setRewards: (state, data) => {
    const rewards = {
      ...state.rewards,
      ...data
    }
    state.rewards = rewards
  },
  setRewardsLoading: (state, data) => {
    const rewardsLoading = {
      ...state.rewardsLoading,
      ...data
    }
    state.rewardsLoading = rewardsLoading
  },
  setExchangeRewardTermAndCondition: (state, data) => {
    state.exchangeRewardTermAndCondition = data
  },
  setRewardHistories: (state, data) => {
    state.rewardHistories = data
  },
  setCoinHistories: (state, data) => {
    state.coinHistories = data
  },
  setGetAllTiersLoading: (state, data) => {
    const getAllTiersLoading = {
      ...state.getAllTiersLoading,
      ...data
    }
    state.getAllTiersLoading = getAllTiersLoading
  }
}
